import { apiUrlFor } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_CHAT=true in .env.local to point chat at the local API.
export const API_URL = apiUrlFor(process.env.REACT_APP_LOCAL_API_CHAT);
